<template>
  <div>
    <Layout>
      <div v-html="pageData" class="container"></div>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/public/layout'
import config from '@/config'
export default {
  data() {
    return {
      id: ''
    };
  },
  methods: {
  },
  computed: {
    pageData() {
      const language = this.$i18n.locale;
      if (language === 'cn') {
        return config.pageData.mobileAboutNews[this.id - 1].chDetails
      } else {
        return config.pageData.mobileAboutNews[this.id - 1].enDetails
      }
    }
  },
  components: {
    Layout
  },
  created() {
    const options = this.$route.query;
    this.id = options.id
  }
}

</script>

<style lang="less" rel="stylesheet/less" scoped>
  @import "index";
</style>
